'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductPagesDataProvider = function () {
  function ProductPagesDataProvider(ProductPages) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ProductPagesDataProvider);
    this.ProductPagesService = ProductPages;
  }

  (0, _createClass3.default)(ProductPagesDataProvider, [{
    key: 'editor',
    value: function editor() {
      // Initialize
      tinymce.EditorManager.editors = [];
      tinymce.init({
        selector: '.tinymce',
        plugins: ['paste', 'link', 'autoresize']
      });
      tinymce.init({
        selector: '.full-tinymce',
        toolbar1: 'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
        toolbar2: 'print preview media | forecolor backcolor emoticons ',
        image_advtab: true,
        plugins: ['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality', 'paste textcolor colorpicker textpattern imagetools toc']
      });
    }
  }, {
    key: 'getCategory',
    value: function getCategory(data, type) {
      return this.ProductPagesService.loadCategories(data).then(function (categories) {
        return categories;
      });
    }
  }, {
    key: 'loadCategoriesNoLimit',
    value: function loadCategoriesNoLimit(parentId) {
      return this.ProductPagesService.loadCategoriesNoLimit(parentId).then(function (categories) {
        return categories;
      });
    }
  }, {
    key: 'saveProductPage',
    value: function saveProductPage(data) {
      return this.ProductPagesService.saveProductPage(data).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: 'updateProductPage',
    value: function updateProductPage(data, type) {
      return this.ProductPagesService.updateProductPage(data, type).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: 'getProductPages',
    value: function getProductPages(data, type) {
      return this.ProductPagesService.loadProductPages(data, type).then(function (result) {
        return result;
      });
    }
  }, {
    key: 'getProductPage',
    value: function getProductPage(id, type) {
      return this.ProductPagesService.getProductPage(id, type).then(function (result) {
        return result;
      });
    }
  }, {
    key: 'getProductPageProducts',
    value: function getProductPageProducts(id, type) {
      return this.ProductPagesService.getProductPageProducts(id, type).then(function (result) {
        return result;
      });
    }
  }, {
    key: 'saveCategory',
    value: function saveCategory(data) {
      return this.ProductPagesService.saveCategory(data).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: 'updateCategoryOrder',
    value: function updateCategoryOrder(data) {
      return this.ProductPagesService.updateCategoryOrder(data).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: 'updateProductPageOrder',
    value: function updateProductPageOrder(data) {
      return this.ProductPagesService.updateProductPageOrder(data).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: 'removeCategory',
    value: function removeCategory(id, type) {
      return this.ProductPagesService.removeCategory(id, type).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: 'getCategoryById',
    value: function getCategoryById(id) {
      return this.ProductPagesService.categoryById(id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: 'updateCategory',
    value: function updateCategory(data) {
      return this.ProductPagesService.updateCategory(data).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: 'getSubCategory',
    value: function getSubCategory(data) {
      return this.ProductPagesService.getSubCategory(data).then(function (categories) {
        return categories;
      });
    }
  }, {
    key: 'updateProductPageStatus',
    value: function updateProductPageStatus(data) {
      return this.ProductPagesService.updateProductPageStatus(data).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: 'removeProductPage',
    value: function removeProductPage(id) {
      return this.ProductPagesService.removeProductPage(id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: 'removeProduct',
    value: function removeProduct(id, apid) {
      return this.ProductPagesService.removeProduct(id, apid).then(function (resp) {
        return resp;
      });
    }
  }]);
  return ProductPagesDataProvider;
}();

// WEBPACK FOOTER //


exports.default = ProductPagesDataProvider;


/** WEBPACK FOOTER **
 ** ./client/app/modules/product-page/services/products.pages.dataprovider.service.js
 **/